<script>
import Layout from "@/router/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import axios from "axios";
import Swal from "sweetalert2";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  page: {
    title: "Dashboard",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Datatable,
    vSelect
  },
  data() {
    return {
      title: "Dashboard",
      loadingTableTools: true,
      loadingTablePenyusun: true,
      loadingTablePelaksanaan: true,
      loadingTableHasilPelaksanaan: true,
      listKetersediaanTools: [],
      listKetersediaanPenyusun: [],
      listPelaksanaan: [],
      listHasilPelaksanaan: [],
      columnKetersediaanTools: [
        { width: "40%", label: "Level", name: "-" },
        { width: "20%", label: "Ada", name: "-" },
        { width: "20%", label: "Tidak Ada", name: "-" },
        { width: "20%", label: "%", name: "-" },
      ],
      columnKetersediaanPenyusun: [
        { width: "40%", label: "Penyusun", name: "-" },
        { width: "10%", label: "1.Knowledgeable", name: "-" },
        { width: "10%", label: "2.Practitioner", name: "-" },
        { width: "10%", label: "3.Advandced", name: "-" },
        { width: "10%", label: "4.Mastery", name: "-" },
        { width: "10%", label: "%", name: "-" },
        { width: "10%", label: "Total", name: "-" },
      ],
      columnPelaksanaan: [
        { width: "70%", label: "Pelaksanaan", name: "-" },
        { width: "30%", label: "Peserta", name: "-" },
      ],
      columnHasilPelaksanaan: [
        { width: "40%", label: "Pelaksanaan", name: "-" },
        { width: "30%", label: "Memenuhi", name: "-" },
        { width: "30%", label: "Tidak Memenuhi", name: "-" },
      ],
      levelLabel: [],
      penyusunLabel: [],
      pelaksanaanLabel: [],
      hasilPelaksanaanLabel: [],
      levelChartOption: [],
      levelChartSeries: [],
      penyusunChartOption: [],
      penyusunChartSeries: [],
      pelaksanaanChartOption: [],
      pelaksanaanChartSeries: [],
      hasilPelaksanaanChartOption: [],
      hasilPelaksanaanChartSeries: [],
      selectedTahun: "All",
      option_tahun: ['All','2024','2025'],
      selectedTahunHasil: "All",
      option_tahun_hasil: ['All','2024','2025'],
    };
  },
  methods: {
    async getLevelChart() {
      this.loadingTableTools = true;
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `dashboard/ketersediaan-tools`,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => {
        if (response.data.meta.code != 200) {
          Swal.fire({
            icon: "error",
            title: "Gagal get data ketersediaan tools",
          });
          console.log(response.data);
          return;
        }

        this.listKetersediaanTools = response.data.data.list;
        this.levelChartSeries = response.data.data.series;
        this.levelLabel = response.data.data.label;
        this.loadingTableTools = false;
        this.setLevelGraph();
      });
    },
    setLevelGraph() {
      this.levelChartOption = {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        title: {
          text: "Ketersediaan Tools Berdasarkan Level Profisiensi",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.levelLabel,
        },
        // yaxis: {
        //   title: {
        //     text: "$",
        //   },
        // },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    },
    async getPenyusunChart() {
      this.loadingTablePenyusun = true;
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `dashboard/ketersediaan-penyusun`,
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => {
        if (response.data.meta.code != 200) {
          Swal.fire({
            icon: "error",
            title: "Gagal get data ketersediaan penyusun",
          });
          console.log(response.data);
          return;
        }

        this.listKetersediaanPenyusun = response.data.data.list;
        this.penyusunChartSeries = response.data.data.series;
        this.penyusunLabel = response.data.data.label;
        this.loadingTablePenyusun = false;
        this.setPenyusunGraph();
      });
    },
    setPenyusunGraph() {
      console.log(this.penyusunLabel);
      this.penyusunChartOption = {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        title: {
          text: "Ketersediaan Tools Berdasarkan Penyusun",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.penyusunLabel,
        },
        // yaxis: {
        //   title: {
        //     text: "$",
        //   },
        // },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    },
    async getPelaksanaan(tahun='All') {
      this.loadingTablePelaksanaan = true;
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `dashboard/pelaksanaan`,
        params: {tahun:tahun},
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => {
        if (response.data.meta.code != 200) {
          Swal.fire({
            icon: "error",
            title: "Gagal get data pelaksanaan",
          });
          console.log(response.data);
          return;
        }

        this.listPelaksanaan = response.data.data.list;
        this.pelaksanaanChartSeries = response.data.data.series;
        this.pelaksanaanLabel = response.data.data.label;
        this.loadingTablePelaksanaan = false;
        this.setPelaksanaanGraph();
      });
    },
    setPelaksanaanGraph() {
      console.log(this.pelaksanaanLabel);
      this.pelaksanaanChartOption = {
        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        title: {
          text: "Pelaksanaan Asesmen Hard Competency",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.pelaksanaanLabel,
          labels: {
              rotate: -45, // ⬅️ Putar label 45 derajat
              style: {
                  fontSize: '12px',
              },
              // optional:
              trim: true, // Memotong label jika terlalu panjang
          }
        },
        // yaxis: {
        //   title: {
        //     text: "$",
        //   },
        // },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    },
    async getHasilPelaksanaan(tahun='All') {
      this.loadingTableHasilPelaksanaan = true;
      await axios({
        method: "get",
        url:
          process.env.VUE_APP_BACKEND_URL_VERSION +
          `dashboard/hasil-pelaksanaan`,
        params: {tahun:tahun},
        headers: {
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }).then((response) => {
        if (response.data.meta.code != 200) {
          Swal.fire({
            icon: "error",
            title: "Gagal get data pelaksanaan",
          });
          console.log(response.data);
          return;
        }

        this.listHasilPelaksanaan = response.data.data.list;
        this.hasilPelaksanaanChartSeries = response.data.data.series;
        this.hasilPelaksanaanLabel = response.data.data.label;
        this.loadingTableHasilPelaksanaan = false;
        this.setHasilPelaksanaanGraph();
      });
    },
    
    setHasilPelaksanaanGraph() {
      console.log(this.hasilPelaksanaanLabel);
      this.hasilPelaksanaanChartOption = {
        chart: {
          type: "bar",
        },
        colors: ["#00E396", "#FF4560"],
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: "55%",
            borderRadius: 5,
            borderRadiusApplication: "end",
          },
        },
        title: {
          text: "Hasil Asesmen Hard Competency",
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          show: true,
          width: 2,
          colors: ["transparent"],
        },
        xaxis: {
          categories: this.hasilPelaksanaanLabel,
          labels: {
              rotate: -45, // ⬅️ Putar label 45 derajat
              style: {
                  fontSize: '12px',
              },
              // optional:
              trim: true, // Memotong label jika terlalu panjang
          }
        },
        // yaxis: {
        //   title: {
        //     text: "$",
        //   },
        // },
        fill: {
          opacity: 1,
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val;
            },
          },
        },
      };
    },
  },
  mounted() {
    this.getLevelChart();
    this.getPenyusunChart();
    this.getPelaksanaan();
    this.getHasilPelaksanaan();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="row" style="margin-bottom: 15px;">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Ketersediaan Tools Berdasarkan Level Profisiensi</div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="columnKetersediaanTools">
                <tbody>
                  <tr v-if="loadingTableTools">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="listKetersediaanTools.length < 1">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, key) in listKetersediaanTools"
                    :key="key"
                  >
                    <td>{{ row.level }}</td>
                    <td class="text-center">{{ row.ada }}</td>
                    <td class="text-center">{{ row.tidak_ada }}</td>
                    <td class="text-center">{{ row.persentase }}%</td>
                  </tr>
                </tbody>
              </datatable>
              <div class="col-12 mt-3">
                <apexchart
                  v-if="levelChartSeries.length > 0"
                  class="apex-charts"
                  :options="levelChartOption"
                  :series="levelChartSeries"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Ketersediaan Tools Berdasarkan Penyusun</div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="columnKetersediaanPenyusun">
                <tbody>
                  <tr v-if="loadingTablePenyusun">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="listKetersediaanPenyusun.length < 1">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, key) in listKetersediaanPenyusun"
                    :key="key"
                  >
                    <td>{{ row.penyusun }}</td>
                    <td class="text-center">{{ row['1.Knowledgeable'] }}</td>
                    <td class="text-center">{{ row['2.Practitioner'] }}</td>
                    <td class="text-center">{{ row['3.Advanced'] }}</td>
                    <td class="text-center">{{ row['4.Mastery'] }}</td>
                    <td class="text-center">{{ row.persentase }}%</td>
                    <td class="text-center">{{ row.total }}</td>
                  </tr>
                </tbody>
              </datatable>
              <div>
                <apexchart
                  v-if="penyusunChartSeries.length > 0"
                  class="apex-charts"
                  :options="penyusunChartOption"
                  :series="penyusunChartSeries"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" style="margin-bottom: 15px;">
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Pelaksanaan Asesmen Hard Competency</div>
            <div class="mb-3 d-flex justify-content-start">
                <v-select
                  id="tahun" 
                  v-model="selectedTahun"
                  :options="option_tahun"
                  label="tahun"
                  placeholder="Semua Tahun"
                  @update:modelValue="getPelaksanaan($event)"
                >
                  <template #option="{ tahun }">
                    {{ tahun }}
                  </template>
                </v-select>
            </div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="columnPelaksanaan">
                <tbody>
                  <tr v-if="loadingTablePelaksanaan">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="listPelaksanaan.length < 1">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, key) in listPelaksanaan"
                    :key="key"
                  >
                    <td>{{ row.pelaksanaan }}</td>
                    <td class="text-center">{{ row.nilai }}</td>
                  </tr>
                </tbody>
              </datatable>
              <div class="col-12 mt-3">
                <apexchart
                  v-if="pelaksanaanChartSeries.length > 0"
                  class="apex-charts"
                  :options="pelaksanaanChartOption"
                  :series="pelaksanaanChartSeries"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div class="col-md-6">
        <div class="card h-100">
          <div class="card-body">
            <div class="card-title">Hasil Asesmen Hard Competency</div>
            <div class="mb-3 d-flex justify-content-start">
                <v-select
                  id="tahun_hasil" 
                  v-model="selectedTahunHasil"
                  :options="option_tahun_hasil"
                  label="tahun_hasil"
                  placeholder="Semua Tahun"
                  @update:modelValue="getHasilPelaksanaan($event)"
                >
                  <template #option="{ tahun_hasil }">
                    {{ tahun_hasil }}
                  </template>
                </v-select>
            </div>
            <div class="d-flex flex-column justify-content-between h-100 pb-3">
              <datatable :columns="columnHasilPelaksanaan">
                <tbody>
                  <tr v-if="loadingTableHasilPelaksanaan">
                    <td colspan="99" class="text-center">
                      <i class="fas fa-spinner fa-spin"></i> Loading
                    </td>
                  </tr>
                  <tr v-else-if="listHasilPelaksanaan.length < 1">
                    <td colspan="99" class="text-center">
                      Data tidak tersedia
                    </td>
                  </tr>
                  <tr
                    v-else
                    v-for="(row, key) in listHasilPelaksanaan"
                    :key="key"
                  >
                    <td>{{ row.pelaksanaan }}</td>
                    <td class="text-center">{{ row['memenuhi'] }}</td>
                    <td class="text-center">{{ row['tidak_memenuhi'] }}</td>
                  </tr>
                </tbody>
              </datatable>
              <div class="col-12 mt-3">
                <apexchart
                  v-if="hasilPelaksanaanChartSeries.length > 0"
                  class="apex-charts"
                  :options="hasilPelaksanaanChartOption"
                  :series="hasilPelaksanaanChartSeries"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
